import { render } from "./App.vue?vue&type=template&id=8a538b74"
import script from "./App.vue?vue&type=script&lang=js"
export * from "./App.vue?vue&type=script&lang=js"

import "./App.vue?vue&type=style&index=0&id=8a538b74&lang=css"

import exportComponent from "/home/adelaplace/PycharmProjects/pumping_tool_frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__